import features from "features";

import { MapContextProvider } from "context/MapContextProvider";

import Layout from "scenes/Layout/_Layout/_Layout";

const Map = (props: any): JSX.Element => {
  const backPath = "/";

  return (
    <Layout title="Map" isFullFill backPath={backPath}>
      <MapContextProvider>
        <features.map.page {...props} />
      </MapContextProvider>
    </Layout>
  );
};

export default Map;
